import { Facebook, Instagram, Linkedin, Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
// Social media URLs are hardcoded here as they're company-specific and not security-sensitive

interface LegalContent {
  terms: string;
  privacy: string;
  cookies: string;
}

export const legalContent: LegalContent = {
  terms: `
Všeobecné obchodné podmienky

1. ÚVODNÉ USTANOVENIA

1.1 Tieto všeobecné obchodné podmienky (ďalej len "VOP") upravujú vzájomné práva a povinnosti medzi:

Poskytovateľom:

Názov: Mgr. Marián Čuprík, advokát
Sídlo: Staré Grunty 18, 84104 Bratislava, Slovenská republika
IČO: 42249180
DIČ: SK1084791499
Email: info@ai-kurzy.online
Telefón: +421 949 110 446 (ďalej len "Poskytovateľ")
a

Účastníkom kurzu (fyzickou alebo právnickou osobou), ktorý sa prihlásil na vzdelávací kurz poskytovateľa (ďalej len "Účastník").

1.2 Tieto VOP sa vzťahujú na všetky vzdelávacie služby poskytované Poskytovateľom, vrátane online a prezenčných kurzov, webinárov a firemných školení v oblasti umelej inteligencie.

1.3 Odoslaním registračného formulára alebo zaplatením kurzového poplatku Účastník potvrdzuje, že sa oboznámil s týmito VOP a súhlasí s nimi v plnom rozsahu.

2. PREDMET SLUŽIEB

2.1 Poskytovateľ sa zaväzuje poskytnúť Účastníkovi vzdelávacie služby v oblasti umelej inteligencie v rozsahu a forme špecifikovanej v popise konkrétneho kurzu dostupnom na webovej stránke Poskytovateľa.

2.2 Kurzy sa delia na:

Základy AI pre všetkých - začiatočnícky kurz pre širokú verejnosť
Pokročilá implementácia AI - pokročilý kurz pre technicky orientovaných užívateľov
Firemné AI školenia - customizované kurzy pre firmy a tímy
Iné špecializované kurzy - podľa aktuálnej ponuky na webovej stránke
2.3 Kurzy môžu byť realizované:

Online formou (live webinár)
Prezenčnou formou (v školiacich priestoroch)
Hybridnou formou (kombinácia online a prezenčnej formy)
V priestoroch klienta (v prípade firemných školení)
2.4 Poskytovateľ si vyhradzuje právo na úpravu obsahu kurzu s cieľom zlepšenia kvality a aktuálnosti poskytovaných informácií.

3. REGISTRÁCIA A PLATOBNÉ PODMIENKY

3.1 Registrácia

Registrácia na kurz sa uskutočňuje prostredníctvom online registračného formulára na webovej stránke Poskytovateľa
Registrácia je záväzná až po uhradení kurzového poplatku
Early bird zľava 20% platí pri registrácii a úhrade najneskôr 14 dní pred začiatkom kurzu
Kapacita kurzov je obmedzená na maximálne 300 účastníkov pri online kurzoch, resp. na počet uvedený v popise kurzu pri prezenčných kurzoch
V prípade naplnenia kapacity kurzu si Poskytovateľ vyhradzuje právo uzavrieť registráciu
Poskytovateľ potvrdí registráciu emailom bezodkladne po prijatí platby
3.2 Platobné podmienky

Cena kurzu je uvedená pri každom kurze na webovej stránke Poskytovateľa
Všetky ceny sú konečné, v prípade platcov DPH je táto uvedená samostatne
Platbu je možné realizovať: a) Bankovým prevodom na účet Poskytovateľa b) Online platbou platobnou kartou c) V prípade firiem na základe vystavenej faktúry (splatnosť 7 dní)
Faktúra bude vystavená do 7 dní od prijatia platby a doručená elektronicky na email uvedený pri registrácii
V prípade firemného školenia môže byť vyžadovaná záloha vo výške 30% z celkovej ceny školenia
4. STORNO PODMIENKY A ZMENY

4.1 Storno zo strany Účastníka:

14 a viac dní pred kurzom - vrátenie 100% sumy
7-13 dní pred kurzom - vrátenie 50% sumy
Menej ako 7 dní pred kurzom - bez nároku na vrátenie platby
V prípade nemožnosti účasti má Účastník právo delegovať na svoje miesto náhradníka bez dodatočných poplatkov, je však povinný o tom informovať Poskytovateľa najneskôr 24 hodín pred začiatkom kurzu
4.2 Storno zo strany Poskytovateľa:

V prípade zrušenia kurzu bude Účastníkovi vrátená plná suma v lehote do 14 dní od oznámenia o zrušení kurzu
Poskytovateľ má právo presunúť termín kurzu s oznámením minimálne 3 dni vopred
Poskytovateľ má právo zmeniť formu kurzu z prezenčnej na online v prípade nepredvídateľných okolností (napr. pandémia, prírodná katastrofa)
V prípade zmeny termínu alebo formy kurzu má Účastník právo na bezplatné storno a vrátenie plnej sumy, ak mu nový termín alebo forma nevyhovuje
4.3 Náhradný termín:

Účastník má možnosť jedenkrát bezplatne presunúť svoju účasť na iný termín rovnakého kurzu, ak o to požiada najneskôr 7 dní pred pôvodným termínom kurzu a ak je dostupný vhodný náhradný termín
Pri presune účasti na termín s vyššou cenou je Účastník povinný doplatiť cenový rozdiel
Pri presune účasti na termín s nižšou cenou sa cenový rozdiel nevracia
5. PRÁVA A POVINNOSTI ÚČASTNÍKA

5.1 Účastník má právo na:

Kvalitnú výuku v súlade s popisom kurzu uvedeným na webovej stránke Poskytovateľa
Študijné materiály v elektronickej forme
Certifikát o absolvovaní kurzu po jeho úspešnom ukončení
Technickú podporu počas kurzu
Prístup k záznamom z online kurzov po dobu 30 dní od konania kurzu, ak je to uvedené v popise kurzu
5.2 Účastník je povinný:

Dodržiavať pokyny lektora a organizačné pokyny Poskytovateľa
Rešpektovať práva ostatných účastníkov
Chrániť poskytnuté študijné materiály pred neoprávneným šírením
Dodržiavať pravidlá etikety v prípade online kurzov (napr. vhodné správanie v chate, rešpektovanie času určeného na otázky)
Zabezpečiť si technické vybavenie potrebné pre účasť na online kurze (stabilné internetové pripojenie, vhodný prehliadač)
Nenarúšať priebeh kurzu nevhodným správaním alebo technickými zásahmi
6. PRÁVA A POVINNOSTI POSKYTOVATEĽA

6.1 Poskytovateľ má právo:

Upraviť obsah kurzu s cieľom zlepšenia kvality a aktuálnosti poskytovaných informácií
Vylúčiť Účastníka z kurzu bez nároku na vrátenie platby v prípade závažného porušenia povinností Účastníka
Použiť anonymizovanú spätnú väzbu Účastníkov na marketingové účely
Zmeniť lektora kurzu v prípade potreby, pričom garantuje zachovanie odbornej úrovne
6.2 Poskytovateľ je povinný:

Zabezpečiť kurz v kvalite a rozsahu uvedenom v popise kurzu
Poskytnúť Účastníkovi všetky potrebné materiály a informácie
Vydať certifikát o absolvovaní kurzu Účastníkovi, ktorý sa zúčastnil celého kurzu
Informovať Účastníkov o prípadných zmenách v organizácii kurzu
Zabezpečiť technickú podporu počas online kurzov
7. OCHRANA DUŠEVNÉHO VLASTNÍCTVA

7.1 Všetky materiály poskytnuté počas kurzu (prezentácie, cvičenia, prípadové štúdie, zdrojové kódy a podobne) sú chránené autorským právom a sú duševným vlastníctvom Poskytovateľa alebo tretích strán, ktoré Poskytovateľovi udelili licenciu na ich použitie.

7.2 Účastník nesmie:

Šíriť poskytnuté materiály tretím osobám
Nahrávať prednášky bez výslovného písomného súhlasu Poskytovateľa
Používať materiály na komerčné účely
Vytvárať odvodené diela na základe poskytnutých materiálov
7.3 Účastník získava nevýhradnú, neprenosnú licenciu na používanie materiálov výhradne pre vlastnú potrebu a vzdelávanie.

7.4 Porušenie ustanovení o ochrane duševného vlastníctva môže viesť k vymáhaniu náhrady škody a k právnemu konaniu.

8. OCHRANA OSOBNÝCH ÚDAJOV

8.1 Poskytovateľ spracúva osobné údaje Účastníka v súlade s Nariadením Európskeho parlamentu a Rady (EÚ) 2016/679 o ochrane fyzických osôb pri spracúvaní osobných údajov (GDPR) a zákonom č. 18/2018 Z. z. o ochrane osobných údajov.

8.2 Účelom spracúvania osobných údajov je poskytovanie služieb, fakturácia, komunikácia s Účastníkom a zasielanie informácií o kurzoch a novinkách, ak k tomu Účastník udelil súhlas.

8.3 Bližšie informácie o spracúvaní osobných údajov sú uvedené v samostatnom dokumente "Ochrana osobných údajov" dostupnom na webovej stránke Poskytovateľa.

9. REKLAMAČNÝ PORIADOK

9.1 Účastník má právo reklamovať kvalitu poskytnutých služieb bezodkladne, najneskôr však do 7 dní od konania kurzu.

9.2 Reklamácia musí byť podaná písomne na emailovú adresu Poskytovateľa (info@ai-kurzy.online) a musí obsahovať identifikáciu Účastníka, názov a termín kurzu, popis nedostatkov a návrh na riešenie reklamácie.

9.3 Poskytovateľ sa zaväzuje vybaviť reklamáciu do 30 dní od jej doručenia.

9.4 V prípade oprávnenej reklamácie má Účastník nárok na:

Primeranú zľavu z ceny kurzu
Bezplatné opakovanie kurzu v inom termíne
Vrátenie časti alebo celej sumy za kurz v závislosti od závažnosti nedostatkov
10. KOMUNIKÁCIA

10.1 Komunikácia medzi Poskytovateľom a Účastníkom prebieha predovšetkým elektronickou formou prostredníctvom emailov.

10.2 Účastník súhlasí s tým, že všetky oznámenia, potvrdenia a dokumenty súvisiace s kurzom mu budú zasielané elektronicky.

10.3 Účastník je povinný udržiavať svoje kontaktné údaje aktuálne a kontrolovať svoju emailovú schránku vrátane priečinka nevyžiadanej pošty (spam).

11. VYŠŠIA MOC

11.1 Ani jedna zo zmluvných strán nenesie zodpovednosť za neplnenie svojich povinností, ak je toto spôsobené okolnosťami vyššej moci (napr. prírodné katastrofy, vojnový stav, pandémia, výpadky internetu mimo kontroly Poskytovateľa).

11.2 V prípade zásahu vyššej moci sa Poskytovateľ zaväzuje informovať Účastníkov bezodkladne a navrhnúť alternatívne riešenie (napr. zmena termínu, zmena formy výuky).

12. ZÁVEREČNÉ USTANOVENIA

12.1 Tieto VOP nadobúdajú účinnosť dňom 1.1.2025.

12.2 Poskytovateľ si vyhradzuje právo na zmenu týchto VOP. Zmena je účinná dňom jej zverejnenia na webovej stránke Poskytovateľa. Pre Účastníka sú záväzné VOP platné v deň úhrady kurzového poplatku.

12.3 Právne vzťahy neupravené týmito VOP sa riadia príslušnými ustanoveniami právnych predpisov Slovenskej republiky, najmä Občianskym zákonníkom a Obchodným zákonníkom.

12.4 Prípadné spory budú riešené prednostne mimosúdnou dohodou. V prípade neúspechu mimosúdneho riešenia bude na riešenie sporov príslušný súd Slovenskej republiky.

12.5 Ak by niektoré ustanovenie týchto VOP bolo neplatné, nemá to vplyv na platnosť ostatných ustanovení.

12.6 Tieto VOP sú vyhotovené v slovenskom jazyku. V prípade vyhotovenia VOP v inom jazyku a nezrovnalosti medzi rôznymi jazykovými verziami je rozhodujúca slovenská verzia.

V Bratislave, dňa 1.1.2025

Skallars s.r.o.
`,
  privacy: `
Zásady ochrany osobných údajov

1. Úvodné ustanovenia

1.1 Prevádzkovateľ osobných údajov:
Human in the Loop s.r.o., so sídlom Bratislava, IČO: 42249180, zapísaná v obchodnom registri (ďalej len "Prevádzkovateľ"), email: info@ai-kurzy.online, týmto v súlade s nariadením Európskeho parlamentu a Rady (EÚ) 2016/679 o ochrane fyzických osôb pri spracúvaní osobných údajov a o voľnom pohybe takýchto údajov (ďalej len "GDPR") a zákonom č. 18/2018 Z. z. o ochrane osobných údajov a o zmene a doplnení niektorých zákonov ustanovuje nasledovné zásady ochrany osobných údajov.

1.2 Tieto zásady ochrany osobných údajov upravujú právne vzťahy Prevádzkovateľa a jeho klientov, obchodných partnerov či iných fyzických osôb (ďalej len "dotknuté osoby") pri spracúvaní ich osobných údajov podľa čl. 4 bod 1 GDPR Prevádzkovateľom prostredníctvom webovej stránky www.ai-kurzy.netlify.sk a počas poskytovania vzdelávacích služieb.

2. Rozsah spracúvaných osobných údajov

2.1 Prevádzkovateľ v súlade so zásadou minimalizácie údajov podľa čl. 5 ods. 1 písm. c) GDPR spracúva nasledovné kategórie osobných údajov dotknutých osôb:

a) Základné identifikačné údaje v rozsahu:

Meno a priezvisko dotknutej osoby
Emailová adresa dotknutej osoby
Telefónne číslo dotknutej osoby
Fakturačné údaje dotknutej osoby alebo spoločnosti, ktorú zastupuje
b) Údaje o absolvovaných vzdelávacích aktivitách v rozsahu:

História absolvovaných kurzov a školení
Dosiahnuté výsledky a hodnotenia
Vydané certifikáty a osvedčenia o absolvovaní
c) Technické a prevádzkové údaje v rozsahu:

IP adresa zariadenia dotknutej osoby
Súbory cookies v súlade s osobitnými podmienkami ich používania
Údaje o používanom prehliadači a zariadení
Štatistické údaje o využívaní služieb
3. Účel spracúvania osobných údajov

3.1 Prevádzkovateľ spracúva osobné údaje dotknutých osôb na nasledovné účely:

a) Poskytovanie vzdelávacích služieb, najmä:

Registrácia a evidencia účastníkov vzdelávacích aktivít
Vystavovanie certifikátov a osvedčení
Komunikácia s účastníkmi ohľadom organizačných záležitostí
Vystavovanie a evidencia daňových dokladov
b) Zlepšovanie kvality poskytovaných služieb:

Analýza návštevnosti webovej stránky
Vyhodnocovanie spokojnosti účastníkov
Optimalizácia obsahu a formy vzdelávacích aktivít
Technická podpora a riešenie prípadných problémov
c) Marketingové účely výhradne na základe osobitného súhlasu:

Zasielanie informačných newsletterov
Informovanie o nových vzdelávacích aktivitách
Poskytovanie personalizovaných ponúk
4. Právny základ spracúvania osobných údajov

4.1 Prevádzkovateľ spracúva osobné údaje dotknutých osôb na základe nasledovných právnych základov v zmysle čl. 6 ods. 1 GDPR:

a) plnenie zmluvy alebo vykonanie opatrení pred uzatvorením zmluvy na žiadosť dotknutej osoby podľa čl. 6 ods. 1 písm. b) GDPR;

b) plnenie zákonných povinností Prevádzkovateľa podľa čl. 6 ods. 1 písm. c) GDPR, najmä povinností vyplývajúcich z:

zákona č. 431/2002 Z. z. o účtovníctve
zákona č. 222/2004 Z. z. o dani z pridanej hodnoty
zákona č. 595/2003 Z. z. o dani z príjmov
c) oprávnené záujmy Prevádzkovateľa podľa čl. 6 ods. 1 písm. f) GDPR, ktorými sú najmä:

ochrana práv a právom chránených záujmov Prevádzkovateľa
zabezpečenie riadneho fungovania webovej stránky
zlepšovanie kvality poskytovaných služieb
d) súhlas dotknutej osoby podľa čl. 6 ods. 1 písm. a) GDPR na marketingové účely.

5. Doba uchovávania osobných údajov

5.1 Prevádzkovateľ uchováva osobné údaje dotknutých osôb po dobu:

a) trvania zmluvného vzťahu s dotknutou osobou a po jeho ukončení až do uplynutia premlčacích lehôt na uplatnenie práv zo zmluvného vzťahu;

b) stanovenú osobitnými predpismi, najmä:

10 rokov pre účtovné doklady podľa zákona o účtovníctve
10 rokov pre daňové doklady podľa zákona o DPH
c) do odvolania súhlasu dotknutej osoby, ak je spracúvanie založené na súhlase;

d) nevyhnutnú na splnenie účelu spracúvania.

6. Práva dotknutých osôb

6.1 Dotknutá osoba má v súvislosti so spracúvaním jej osobných údajov nasledovné práva:

a) Právo na prístup k osobným údajom podľa čl. 15 GDPR
b) Právo na opravu osobných údajov podľa čl. 16 GDPR
c) Právo na vymazanie osobných údajov podľa čl. 17 GDPR
d) Právo na obmedzenie spracúvania podľa čl. 18 GDPR
e) Právo na prenosnosť údajov podľa čl. 20 GDPR
f) Právo namietať proti spracúvaniu podľa čl. 21 GDPR
g) Právo odvolať súhlas so spracúvaním
h) Právo podať sťažnosť dozornému orgánu

6.2 Dotknutá osoba môže uplatniť svoje práva:

Elektronicky na emailovej adrese: info@ai-kurzy.online
Písomne na adrese sídla Prevádzkovateľa
Osobne v sídle Prevádzkovateľa
6.3 Prevádzkovateľ poskytne dotknutej osobe informácie o opatreniach, ktoré sa prijali na základe jej žiadosti, bez zbytočného odkladu a v každom prípade do jedného mesiaca od doručenia žiadosti. Uvedená lehota sa môže v prípade potreby predĺžiť o ďalšie dva mesiace, pričom sa zohľadí komplexnosť žiadosti a počet žiadostí.

7. Bezpečnosť spracúvania

7.1 Prevádzkovateľ prijal primerané technické a organizačné opatrenia s cieľom zaistiť úroveň bezpečnosti primeranú riziku pre práva a slobody dotknutých osôb, najmä:

a) Technické opatrenia:

Šifrovanie osobných údajov
Zabezpečenie trvalej dôvernosti, integrity, dostupnosti a odolnosti systémov
Firewall a antivírusová ochrana
Pravidelné zálohovanie údajov
Zabezpečený prenos údajov
b) Organizačné opatrenia:

Riadenie prístupových práv zamestnancov
Pravidelné školenia zamestnancov
Interné bezpečnostné smernice a postupy
Pravidelný audit bezpečnostných opatrení
8. Príjemcovia osobných údajov

8.1 Prevádzkovateľ poskytuje osobné údaje dotknutých osôb nasledovným kategóriám príjemcov:

a) Poskytovatelia IT služieb a technickej podpory
b) Poskytovatelia účtovných a daňových služieb
c) Advokátske kancelárie
d) Orgány verejnej moci v rozsahu ich zákonných oprávnení

8.2 S príjemcami osobných údajov sú uzatvorené zmluvy o spracúvaní osobných údajov v súlade s čl. 28 GDPR, ktoré zabezpečujú primeranú úroveň ochrany osobných údajov.

9. Medzinárodný prenos osobných údajov

9.1 Prevádzkovateľ primárne spracúva osobné údaje v rámci Európskej únie a Európskeho hospodárskeho priestoru.

9.2 V prípade prenosu osobných údajov do tretích krajín Prevádzkovateľ zabezpečí primeranú úroveň ochrany osobných údajov v súlade s kapitolou V GDPR.

10. Zmeny zásad ochrany osobných údajov

10.1 Prevádzkovateľ si vyhradzuje právo kedykoľvek zmeniť alebo doplniť tieto zásady ochrany osobných údajov.

10.2 O podstatných zmenách týchto zásad bude Prevádzkovateľ informovať dotknuté osoby vopred prostredníctvom emailovej správy alebo oznámením na webovej stránke.

11. Záverečné ustanovenia

11.1 Tieto zásady ochrany osobných údajov nadobúdajú účinnosť dňom [Dátum].

11.2 Pre otázky týkajúce sa ochrany osobných údajov, ktoré nie sú upravené týmito zásadami, sa použijú príslušné ustanovenia GDPR a zákona č. 18/2018 Z. z. o ochrane osobných údajov.

12. Kontaktné údaje

Pre akékoľvek otázky alebo podnety týkajúce sa spracúvania osobných údajov môžete kontaktovať Prevádzkovateľa:

Email: info@ai-kurzy.online
Tel.: +421 949 110 446

Posledná aktualizácia: 1.1.2025
Platnosť od: 1. 8. 2024
`,
  cookies: `
Zásady používania cookies
Platnosť od: 1. 8. 2024

1. Čo sú cookies?

Cookies predstavujú malé textové súbory obsahujúce údaje o aktivite používateľa, ktoré sa pri návšteve webovej stránky www.ai-kurzy.sk ukladajú do koncového zariadenia používateľa (počítač, tablet, mobilný telefón alebo iné zariadenie s prístupom na internet) prostredníctvom webového prehliadača za účelom zachovania funkčnosti webovej stránky, zlepšovania poskytovaných služieb a prispôsobovania obsahu individuálnym potrebám používateľov.

2. Typy cookies, ktoré používame

Používame nasledujúce kategórie cookies:

2.1 Nevyhnutné (technické) cookies

a) Účel spracúvania: Zabezpečenie základnej funkčnosti webovej stránky a jej technickej stability
b) Právny základ: Oprávnený záujem Prevádzkovateľa podľa čl. 6 ods. 1 písm. f) GDPR
c) Doba uchovávania: Počas trvania relácie (session)
d) Možnosť deaktivácie: Nie je možné deaktivovať vzhľadom na ich nevyhnutnosť pre fungovanie webovej stránky

2.2 Analytické cookies (vyžadujú súhlas)

Tieto cookies nám pomáhajú pochopiť, ako návštevníci používajú našu webovú stránku, aký obsah ich zaujíma a ako sa na stránku dostali. Tieto informácie používame na zlepšenie funkčnosti a obsahu stránky. Používame službu Google Analytics.

a) Účel: Zber anonymizovaných štatistických údajov o návštevnosti a interakciách používateľov.
b) Poskytovateľ: Google LLC (prostredníctvom Google Ireland Limited).
c) Príklady cookies a doba uchovávania:
   - _ga: Používa sa na rozlíšenie používateľov, doba uchovávania typicky 2 roky.
   - _gid: Používa sa na rozlíšenie používateľov, doba uchovávania typicky 24 hodín.
   - _gat_*: Používa sa na obmedzenie počtu požiadaviek odosielaných na servery Google, doba uchovávania typicky 1 minúta.
d) Zdieľanie údajov: Anonymizované údaje sú zdieľané so spoločnosťou Google na účely analýzy. Viac informácií nájdete v Zásadách ochrany osobných údajov Google.
e) Možnosť deaktivácie: Áno. Tieto cookies sa nastavia iba vtedy, ak nám udelíte súhlas prostredníctvom cookie bannera alebo nastavení cookies. Svoj súhlas môžete kedykoľvek zmeniť alebo odvolať v nastaveniach cookies dostupných v pätičke stránky.

2.3 Marketingové cookies (momentálne nepoužívame)

3. Správa súhlasu s cookies

Pri vašej prvej návšteve webovej stránky sa zobrazí informačný banner, ktorý vás požiada o súhlas s používaním analytických a prípadne marketingových cookies. Svoje preferencie môžete:

a) Prijať všetky cookies.
b) Odmietnuť všetky voliteľné cookies (budú použité len nevyhnutné).
c) Upraviť si nastavenia a vybrať, ktoré kategórie voliteľných cookies povolíte.

Svoj súhlas môžete kedykoľvek zmeniť alebo odvolať prostredníctvom odkazu "Nastavenia cookies" v pätičke našej webovej stránky. Zmena nastavení sa prejaví pri vašej ďalšej návšteve alebo po obnovení stránky.

Väčšina webových prehliadačov tiež umožňuje kontrolovať cookies prostredníctvom svojich nastavení. Môžete si nastaviť prehliadač tak, aby vás upozornil na prijatie cookies, alebo ich úplne zablokovať. Informácie o správe cookies v bežných prehliadačoch nájdete na nasledujúcich odkazoch:

Google Chrome: Nastavenia > Súkromie a bezpečnosť > Cookies a ďalšie údaje stránok
Mozilla Firefox: Možnosti > Súkromie a bezpečnosť > Cookies a údaje stránok
Safari: Predvoľby > Súkromie > Cookies a údaje webových stránok
Microsoft Edge: Nastavenia > Súkromie, vyhľadávanie a služby > Cookies

4. Doba uchovávania cookies

Prevádzkovateľ uchováva jednotlivé typy cookies po nasledovnú dobu:

a) Session cookies: Do momentu ukončenia relácie (zatvorenia prehliadača)
b) Permanentné cookies: Maximálne 24 mesiacov od poslednej návštevy
c) Marketingové cookies: Maximálne 12 mesiacov od udelenia súhlasu
d) Analytické cookies: Maximálne 24 mesiacov od poslednej návštevy

5. Príjemcovia údajov z cookies

Prevádzkovateľ poskytuje údaje získané prostredníctvom cookies nasledovným príjemcom:

a) Google Ireland Limited (Google Analytics)
b) Facebook Ireland Ltd. (Facebook Pixel)
c) LinkedIn Ireland Unlimited Company (LinkedIn Insight)

Všetci príjemcovia spracúvajú údaje v súlade s príslušnými právnymi predpismi a majú sídlo v rámci Európskej únie alebo zabezpečujú primeranú úroveň ochrany osobných údajov.

6. Aktualizácia zásad používania cookies

Prevádzkovateľ pravidelne prehodnocuje a aktualizuje tieto zásady, najmä:

a) Pri zavedení nových technológií alebo funkcionalít
b) Pri zmene príslušnej legislatívy
c) Pri zmene spôsobu spracúvania cookies
d) Minimálne raz ročne

O podstatných zmenách týchto zásad bude Prevádzkovateľ informovať používateľov prostredníctvom webovej stránky.

7. Záverečné ustanovenia

Tieto zásady používania cookies nadobúdajú účinnosť dňom [Dátum].

Pre otázky neupravené týmito zásadami sa použijú príslušné ustanovenia GDPR, zákona č. 18/2018 Z. z. o ochrane osobných údajov a zákona č. 351/2011 Z. z. o elektronických komunikáciách.

8. Kontaktné údaje

Pre akékoľvek otázky týkajúce sa používania cookies môžete kontaktovať Prevádzkovateľa:

Email: info@ai-kurzy.online
Tel.: 0949110446

Posledná aktualizácia: 1.1.2025
Platnosť od: 1. 8. 2024
`,
};

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-50 dark:bg-gray-800/70">
      <div className="container px-4 mx-auto py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <h3 className="text-lg font-semibold mb-4 dark:text-white">Kontakt</h3>
            <div className="space-y-3">
              <p className="flex items-center gap-2 text-gray-600 dark:text-gray-100">
                <Mail className="w-5 h-5 dark:text-gray-50" />
                <a href="mailto:info@ai-kurzy.online" className="hover:text-blue-600 dark:hover:text-blue-300">
                info@ai-kurzy.online
                </a>
              </p>
              <div className="flex items-center gap-4 mt-4">
                <a
                  href="https://www.facebook.com/kurzyAI"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-blue-600 dark:text-gray-100 dark:hover:text-blue-300"
                >
                  <Facebook className="w-6 h-6" />
                </a>
                <a
                  href="https://www.instagram.com/aikurzyonline/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-pink-600 dark:text-gray-100 dark:hover:text-pink-300"
                >
                  <Instagram className="w-6 h-6" />
                </a>
                <a
                  href="https://www.linkedin.com/showcase/ai-kurzy-online/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-blue-600 dark:text-gray-100 dark:hover:text-blue-300"
                >
                  <Linkedin className="w-6 h-6" />
                </a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 dark:text-white">Dokumenty</h3>
            <div className="space-y-2">
              <button
                onClick={() => navigate('/vop')}
                className="block text-gray-600 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-300"
              >
                Všeobecné obchodné podmienky
              </button>
              <button
                onClick={() => navigate('/privacy')}
                className="block text-gray-600 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-300"
              >
                Ochrana osobných údajov
              </button>
              <button
                onClick={() => navigate('/cookies')}
                className="block text-gray-600 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-300"
              >
                Cookies
              </button>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-700">
          <p className="text-center text-gray-600 dark:text-gray-100">
            {new Date().getFullYear()} Human in the Loop s.r.o. Všetky práva vyhradené.
          </p>
        </div>
      </div>
    </footer>
  );
}